import {
  Group,
  Tabs,
  Text,
  type PolymorphicComponentProps,
  type TabsTabProps
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import classNames from "classnames";
import { OrangeCircle } from "../../../components/OrangeCircle/OrangeCircle";
import { THEME_VARS } from "../../../utils/constants";

interface TabWithHighlightAndErrorProps
  extends
    Omit<TabsTabProps, "rightSection">,
    Partial<PolymorphicComponentProps<TabsTabProps>> {
  numErrors?: number;
  highlighted?: boolean;
}

function TabWithHighlightAndError({
  numErrors = 0,
  className,
  highlighted = false,
  ...tabProps
}: TabWithHighlightAndErrorProps) {
  return (
    <Tabs.Tab
      className={classNames(
        "TabWithHighlightAndError",
        { highlighted: highlighted },
        className
      )}
      rightSection={
        (numErrors > 0 || highlighted) && (
          <Group gap="xs">
            {numErrors > 0 && (
              <>
                <IconAlertTriangle
                  aria-label="Fehler"
                  color={THEME_VARS.error[6]}
                  size="1.1rem"
                />
                <Text c="error">{numErrors}</Text>
              </>
            )}
            {highlighted && <OrangeCircle />}
          </Group>
        )
      }
      {...tabProps}
    />
  );
}

export { TabWithHighlightAndError, TabWithHighlightAndErrorProps };
